// extracted by mini-css-extract-plugin
export default {"stepIndicator":"StepIndicator_stepIndicator__tgeuf","fullwidthbar":"StepIndicator_fullwidthbar__8emji","stepbar":"StepIndicator_stepbar__kSQvA"};